
<div class="container">

  <div class="container-toggle">
    <mat-slide-toggle class="toggle" (change)="changeToggle($event)" [(ngModel)]="isChecked">{{labelToggle}}</mat-slide-toggle>
  </div>

  @if (isChecked) {
    <data-table
      [title]='"Equipos Activos"'
      [columns]='columnasEquipos'
      [configuration]='configurationEquipos'
      [reloadTable]='recargarTablaEquipos'
      (active)='inactivateOrActiveEquipment($event, false)'
      (edit)='editarEquipos($event)'
      (view)='clickFilaEquipos($event)'
      [params]='[]'
      [url]='urlGetEquipos'
      (add)='agregarEquipos($event)'
      [headerFilters]="headerFilters"
    ></data-table>
  }

  @if (!isChecked) {
    <data-table
      [title]='"Equipos Inactivos"'
      [columns]='columnasEquipos'
      [configuration]='configurationEquipos'
      [reloadTable]='recargarTablaEquiposInactives'
      (active)='inactivateOrActiveEquipment($event, true)'
      (clickRow)='inactivateOrActiveEquipment($event, true)'
      [params]='params2'
      [url]='urlGetEquipos'
      (add)='agregarEquipos($event)'
      [headerFilters]="headerFilters"
    ></data-table>
  }


</div>
